import LazyEditorController from "../../lazy_editor_controller"

export default class extends LazyEditorController {
    static values = { schema: Object, placeholders: { type: Array, default: [] } }

    loadEditor() { return import("./editor") }
}
